
import { User, PurchaseHistory } from '@/types/user';
import { supabase } from "@/integrations/supabase/client";
import { toast } from '@/hooks/use-toast';

export const useLogin = (
  setUser: React.Dispatch<React.SetStateAction<User | null>>,
  setPurchaseHistory: React.Dispatch<React.SetStateAction<PurchaseHistory[]>>,
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const login = async (email: string, password: string): Promise<boolean> => {
    console.log('Login attempt for:', email);
    
    setIsLoading(true);
    
    try {
      const { data, error } = await supabase.auth.signInWithPassword({
        email,
        password
      });
      
      if (error) {
        console.error('Login error:', error.message);
        toast({
          title: "Login failed",
          description: error.message,
          variant: "destructive",
          duration: 3000
        });
        return false;
      }
      
      if (data.user) {
        console.log('Login successful for user:', data.user.id);
        toast({
          title: "Login successful",
          description: "Welcome back!",
          duration: 2000
        });
        return true;
      }
      
      return false;
      
    } catch (error: any) {
      console.error('Login exception:', error);
      toast({
        title: "Login failed",
        description: "Please try again",
        variant: "destructive",
        duration: 3000
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { login };
};
